/**
 * Reassign rules for Completed tasks.
 *
 * A Completed task is normally final and can't be reassigned. The one
 * exception is a task completed *unsuccessfully* (`success === false`) in a
 * workflow listed in REASSIGN_UNSUCCESSFUL_WORKFLOW_IDS -- those can be sent
 * back out to field agents. Tasks in any other status are unaffected.
 */
export const REASSIGN_UNSUCCESSFUL_WORKFLOW_IDS = ["153"];

const getTaskWorkflowId = (task, fallbackWorkflowId) =>
  task?.workflowId ?? task?.workflowID ?? task?.activityId ?? fallbackWorkflowId;

// True when the task belongs to a workflow that has the unsuccessful-completed
// reassign exception (used to pick which toast to show when it is blocked).
export const isReassignExceptionWorkflow = (task, fallbackWorkflowId) =>
  REASSIGN_UNSUCCESSFUL_WORKFLOW_IDS.includes(
    String(getTaskWorkflowId(task, fallbackWorkflowId) ?? "").trim()
  );

// `fallbackWorkflowId` is the currently selected workflow (activityId), used
// when the task row itself doesn't carry its workflow id. It can be a
// comma-separated list; only a single selected workflow counts as a match.
export const canReassignTask = (task, fallbackWorkflowId) => {
  if (task?.taskStatus !== "Completed") return true;
  if (task?.success !== false) return false;
  const workflowId = String(getTaskWorkflowId(task, fallbackWorkflowId) ?? "").trim();
  return REASSIGN_UNSUCCESSFUL_WORKFLOW_IDS.includes(workflowId);
};
